/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TixButtonModule } from '../button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TixCardModule } from './../card/card.module';
import { TixIconModule } from './../icon/icon.module';
import { TixConfirmDeleteDialogComponent } from './confirm-delete-dialog/confirm-delete-dialog.component';
import { TixConfirmDeleteDialogService } from './confirm-delete-dialog/confirm-delete-dialog.service';
import { TixConfirmDialogComponent } from './confirm/confirm-dialog.component';
import { TixConfirmDialogService } from './confirm/confirm-dialog.service';
import { TixDialog, TIX_DIALOG_SCROLL_STRATEGY_PROVIDER } from './dialog';
import { TixDialogContainerComponent } from './dialog-container';
import {
  TixDialogActions,
  TixDialogClose,
  TixDialogContent,
  TixDialogTitle
} from './dialog-content-directives';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeroExclamationCircle, TixIconRegistry } from '../icon';
import { CheckboxSelectDialogComponent } from './checkbox-select-dialog/checkbox-select-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    PortalModule,
    TixCardModule,
    TixButtonModule,
    TixIconModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatRippleModule
  ],
  exports: [
    TixDialogContainerComponent,
    TixDialogClose,
    TixDialogTitle,
    TixDialogContent,
    TixDialogActions,
    TixConfirmDialogComponent
  ],
  declarations: [
    TixConfirmDeleteDialogComponent,
    TixDialogContainerComponent,
    TixDialogClose,
    TixDialogTitle,
    TixDialogActions,
    TixDialogContent,
    TixConfirmDialogComponent,
    TixConfirmDeleteDialogComponent,
    CheckboxSelectDialogComponent
  ],
  providers: [
    TixDialog,
    TixConfirmDeleteDialogService,
    TixConfirmDialogService,
    TIX_DIALOG_SCROLL_STRATEGY_PROVIDER
  ]
})
export class TixDialogModule {
  constructor(iconRegistry: TixIconRegistry) {
    iconRegistry.addSvgIconConfig(HeroExclamationCircle);
  }
}
